module.exports = __webpack_public_path__ + "static/media/DSC_2895.1e31959f.jpg";